export const CARD_PIN_LENGTH = 6;

export const CARD_PIN_VALIDATION_ERRORS = Object.freeze({
  FORMAT: 'format',
  REPEATED_DIGITS: 'repeatedDigits',
  CONSECUTIVE_DIGITS: 'consecutiveDigits',
});

function hasConsecutiveDigits(pin) {
  const digits = Array.from(pin, Number);

  return digits.some((digit, index) => {
    if (index > digits.length - 3) {
      return false;
    }

    const firstStep = digits[index + 1] - digit;
    const secondStep = digits[index + 2] - digits[index + 1];

    return (firstStep === 1 && secondStep === 1)
      || (firstStep === -1 && secondStep === -1);
  });
}

export function getCardPinValidationError(value) {
  const pin = String(value ?? '').trim();

  if (!new RegExp(`^\\d{${CARD_PIN_LENGTH}}$`).test(pin)) {
    return CARD_PIN_VALIDATION_ERRORS.FORMAT;
  }

  if (new Set(pin).size !== CARD_PIN_LENGTH) {
    return CARD_PIN_VALIDATION_ERRORS.REPEATED_DIGITS;
  }

  if (hasConsecutiveDigits(pin)) {
    return CARD_PIN_VALIDATION_ERRORS.CONSECUTIVE_DIGITS;
  }

  return null;
}

export function isValidCardPin(value) {
  return getCardPinValidationError(value) === null;
}
